import './styles/leads.scss';
import './images/field.png';
import './images/export.png';

import ColumnDisplayHelper from './scripts/column-display-helper';

document.addEventListener('DOMContentLoaded', () => {
    ColumnDisplayHelper();
});
